const dev = {
    API_URL: "https://kii1p7zfb8.execute-api.us-west-2.amazonaws.com/live",
};

const prod = {
    API_URL: "https://kii1p7zfb8.execute-api.us-west-2.amazonaws.com/live",
};

const config = process.env.REACT_APP_ENV === "PROD" ? prod : dev;

export default config
